export class PriceInfo {
    public sum: number;

    public price: number;

    public totalPrice: number;

    constructor(data?: Partial<PriceInfo>) {
        this.sum = data?.sum;
        this.price = data?.price;
        this.totalPrice = data?.totalPrice;
    }
}
